import { IAlarmEvent } from 'plugin-codaf-risk-ext-bowtie/types/alarms'

import {
    ChartState,
    IEscalationFactor,
    ChartEvent,
    IBarrier,
    IThreat,
    IConsequence,
    ITopEvent,
    IBowtie
} from '../types'

export class Listener {
    listeners: (() => void)[] = []

    registerListener(callback: () => void): void {
        this.listeners = [...this.listeners, callback]
    }

    removeListener(callback: () => void): void {
        this.listeners = this.listeners.filter(el => el !== callback)
    }

    trigger(): void {
        this.listeners.forEach(listener => {
            if (listener) listener()
        })
    }
}
export interface Stated {
    listener: Listener
    event?: ChartEvent

    fillWithEvent(state: ChartState): void
}

export class EscalationFactorView implements Stated {
    public escalationFactor: IEscalationFactor
    public event?: ChartEvent
    public barriersView: BarrierView[]
    public listener: Listener

    constructor(escalationFactor: IEscalationFactor, barriersView: BarrierView[]) {
        this.listener = new Listener()
        this.escalationFactor = escalationFactor
        this.barriersView = barriersView
    }

    fillWithEvent(state: ChartState): void {
        const isOk = state.escalations.has(this.escalationFactor.id)
        this.event = isOk ? state.escalations.get(this.escalationFactor.id) : null
        this.barriersView?.forEach(bar => bar.fillWithEvent(state))
        this.listener.trigger()
    }
}
export class BarrierView implements Stated {
    public barrier: IBarrier
    public event?: ChartEvent
    public escalationFactorsView: EscalationFactorView[]
    public listener: Listener

    constructor(barrier: IBarrier, escalationFactorsView: EscalationFactorView[]) {
        this.listener = new Listener()
        this.barrier = barrier
        this.escalationFactorsView = escalationFactorsView
    }

    fillWithEvent(state: ChartState): void {
        const isOk = state.barriers.has(this.barrier.id)
        this.event = isOk ? state.barriers.get(this.barrier.id) : null
        this.escalationFactorsView?.forEach(esc => esc.fillWithEvent(state))
        this.listener.trigger()
    }
}

export class ThreatView implements Stated {
    public threat: IThreat
    public event?: ChartEvent
    public barriersView: BarrierView[]
    public listener: Listener

    constructor(threat: IThreat, barriersView: BarrierView[]) {
        this.threat = threat
        this.barriersView = barriersView
        this.listener = new Listener()
    }

    fillWithEvent(state: ChartState): void {
        const isOk = state.threats.has(this.threat.id)
        this.event = isOk ? state.threats.get(this.threat.id) : null
        this.barriersView?.forEach(bar => bar.fillWithEvent(state))
        this.listener.trigger()
    }
}
export class ConsequenceView implements Stated {
    public consequence: IConsequence
    public event?: ChartEvent
    public barriersView: BarrierView[]
    public listener: Listener

    constructor(consequence: IConsequence, barriersView: BarrierView[]) {
        this.consequence = consequence
        this.barriersView = barriersView
        this.listener = new Listener()
    }

    fillWithEvent(state: ChartState): void {
        const isOk = state.consequences.has(this.consequence.id)
        this.event = isOk ? state.consequences.get(this.consequence.id) : null

        this.barriersView?.forEach(bar => bar.fillWithEvent(state))
        this.listener.trigger()
    }
}
export class TopEventView implements Stated {
    public topEvent: ITopEvent
    public event?: ChartEvent

    public threatsView: ThreatView[]
    public consequencesView: ConsequenceView[]
    public listener: Listener

    constructor(topEvent: ITopEvent, threatsView: ThreatView[], consequencesView: ConsequenceView[]) {
        this.topEvent = topEvent
        this.threatsView = threatsView
        this.consequencesView = consequencesView
        this.listener = new Listener()
    }

    fillWithEvent(state: ChartState): void {
        const isOk = state.topEvents.has(this.topEvent.id)
        this.event = isOk ? state.topEvents.get(this.topEvent.id) : null

        this.consequencesView?.forEach(cons => cons.fillWithEvent(state))
        this.threatsView?.forEach(tr => tr.fillWithEvent(state))
        this.listener.trigger()
    }
}
export class BowtieView implements Stated {
    public bowtie: IBowtie
    public topEventView: TopEventView
    public listener: Listener
    public event?: ChartEvent

    constructor(bowtie: IBowtie, topEventView: TopEventView) {
        this.bowtie = bowtie
        this.topEventView = topEventView
        this.listener = new Listener()
    }

    fillWithEvent(state: ChartState): void {
        const isOk = state.topEvents.has(this.topEventView.topEvent.id)
        this.event = isOk ? state.topEvents.get(this.topEventView.topEvent.id) : null
        this.topEventView.fillWithEvent(state)
        this.listener.trigger()
    }
}
export class AlarmView implements Stated {
    public alarm: IAlarmEvent
    public event?: ChartEvent

    public listener: Listener

    constructor(alarm: IAlarmEvent) {
        this.alarm = alarm
        this.listener = new Listener()
    }

    fillWithEvent(state: ChartState): void {
        const isOk = state.topEvents.has(this.alarm.id)
        this.event = isOk ? state.topEvents.get(this.alarm.id) : null

        this.listener.trigger()
    }
}
